import { Component, OnInit, inject } from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {HuntersService} from '../../service/hunters.service';
import {DynamicHooksComponent} from 'ngx-dynamic-hooks';

@Component({
	selector: 'hunters-intro-component',
	template: `
		<ngx-dynamic-hooks
				[options]="{ sanitize: false }"
				[content]="intro?.toString()">
		</ngx-dynamic-hooks>`,
	standalone: true,
	imports: [DynamicHooksComponent],
})
export class HuntersIntroComponent implements OnInit {
	private huntersService = inject(HuntersService);

	intro: SafeHtml;

	ngOnInit() {
		this.huntersService.getHuntersIntro().then(result => {
			this.intro = result[0].intro;
		});
	}
}
